const convertDecimalToYearsAndMonths = (decimal) => {
  const years = Math.floor(decimal);
  const months = Math.round((decimal - years) * 12);
  return { years, months };
};

export { convertDecimalToYearsAndMonths };
